module.exports = __webpack_public_path__ + "media/icons/chevron-feather-863d9eb9.svg";